import { LogoHeader } from "../../Components/Inicio/LogoHeaderComponent";
import { NavDesktop } from "../../Components/Inicio/NavDesktop";
import { NavMobile } from "../../Components/Inicio/NavMobile";
import { Footer } from "../../Components/Footer/FooterComponent";
import SponsorsListComponent from "../../Components/Patrocinadores/SponsorsListComponnet";

export const SponsorsListPage = (props) => {


    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            <SponsorsListComponent I18n={props.I18n} user={props.User} /> 
            <Footer I18n={props.I18n} />
        </>
    );
}
